<template lang="html">
  <div class="var-select">
    <div class="var-select-container">
      <span class="var-name">{{ user.first_name }} {{ user.last_name }}</span>
      <multiselect
        v-model="selectedOrgs"
        :options="orgs"
        track-by="id"
        :multiple="true"
        label="name"
      />
      <UiButton @click="removeVAR(user.user_id)">
        Remove
      </UiButton>
    </div>
    <div class="statuses">
      <UiProgressCircular class="loading" v-if="loading" />
      <span v-if="error" style="color: red">{{ error }}</span>
      <span v-if="success" class="success">Success!!!</span>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState, mapActions, mapGetters } from 'vuex';
import { UiProgressCircular, UiButton } from 'keen-ui';
import { sleep } from '@/utils';

export default {
  name: 'ValueAddedResalerSelect',
  props: ['user'],
  computed: {
    ...mapState({
      orgs: state => state.Orgs.orgs,
    }),
    ...mapGetters({
      showError: 'Orgs/showError',
    }),
    selectedOrgs: {
      get() {
        return this.orgs.filter(o => this.user.org_ids.includes(o.id));
      },
      set(val) {
        this.update({ userId: this.user.user_id, orgs: val });
      },
    },
    error() {
      return this.user.error;
    },
    loading() {
      return this.user.loading;
    },
  },
  data() {
    return {
      success: false,
    };
  },
  components: {
    Multiselect,
    UiProgressCircular,
    UiButton,
  },
  methods: {
    ...mapActions({
      updateVarAssociatedOrgs: 'VARs/updateVarAssociatedOrgs',
      removeVAR: 'VARs/removeVAR',
    }),
    async update(payload) {
      this.success = false;
      await this.updateVarAssociatedOrgs(payload);
      if (!this.error) {
        this.success = true;
        await sleep(4000);
        this.success = false;
      }
    },
  },
  hagridActions: ['VARs/fetch', 'Orgs/fetch'],
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.var-select {
  button {
    margin-left: 10px;
  }
  .var-name {
    min-width: 150px;
    margin-right: 10px;
  }
  .var-select-container {
    display: flex;
    margin: auto;
    width: 90%;
    align-items: center;
    padding-bottom: 10px;
  }
  .statuses {
    height: 32px;
    width: 0;
    margin: 0 auto;
    position: relative;
    > * {
      position: absolute;
    }
  }
  .success {
    color: green;
    width: auto;
  }
  .error {
    color: red;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ValueAddedResalerSelect.vue